import { render, staticRenderFns } from "./HighlightTextField.vue?vue&type=template&id=36a522eb&scoped=true"
import script from "./HighlightTextField.vue?vue&type=script&lang=js"
export * from "./HighlightTextField.vue?vue&type=script&lang=js"
import style0 from "./HighlightTextField.vue?vue&type=style&index=0&id=36a522eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a522eb",
  null
  
)

export default component.exports